import styles from "./HomeExplorer.module.css";
import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { ReactComponent as IconExpand } from "./assets/icon-expand.svg";
import { ReactComponent as IconCollapse } from "./assets/icon-expand.svg";

import { ReactComponent as IconAddAsset } from "./assets/icon-add-asset.svg";
import { ReactComponent as IconAddBot } from "./assets/icon-add-bot.svg";
import { ReactComponent as IconAddContact } from "./assets/icon-add-contact.svg";
import { ReactComponent as IconContracted } from "./assets/iconContracted.svg";
import { ReactComponent as IconAddEvent } from "./assets/icon-add-event.svg";
import { ReactComponent as IconAddFolder } from "./assets/icon-add-folder.svg";
import { ReactComponent as IconAddTable } from "./assets/icon-add-table.svg";
import { ReactComponent as IconAddWorkflow } from "./assets/icon-add-workflow.svg";
import { ReactComponent as IconBots } from "./assets/icon-bots.svg";
import { ReactComponent as IconCalendar } from "./assets/icon-calendar.svg";
import { ReactComponent as IconChats } from "./assets/icon-chats.svg";
import { ReactComponent as IconConf } from "./assets/icon-conf.svg";
import { ReactComponent as IconContact } from "./assets/icon-contact.svg";
import { ReactComponent as IconDocument } from "./assets/icon-document.svg";
import { ReactComponent as IconExploreCommunity } from "./assets/icon-explore-community.svg";
import { ReactComponent as IconAsset } from "./assets/icon-asset.svg";
import { ReactComponent as IconHelp } from "./assets/icon-help.svg";
import { ReactComponent as IconMore } from "./assets/icon-more.svg";
import { ReactComponent as IconPanel } from "./assets/icon-panel.svg";
import { ReactComponent as IconStar } from "./assets/icon-star.svg";
import { ReactComponent as IconSuggestion } from "./assets/icon-suggestion.svg";
import { ReactComponent as IconTable } from "./assets/icon-table.svg";
import { ReactComponent as IconTables } from "./assets/icon-tables.svg";
import { ReactComponent as IconTransaction } from "./assets/icon-transaction.svg";
import { ReactComponent as IconUpload } from "./assets/icon-upload.svg";
import { ReactComponent as IconWorkflows } from "./assets/icon-workflows.svg";
import { ReactComponent as IconAddTransaction } from "./assets/icon-add-transaction.svg";
import { ReactComponent as IconWorkspace } from "./assets/icon-workspace.svg";
import { ReactComponent as IconDoc } from "./assets/icon-doc.svg";
import { ReactComponent as IconAddChat } from "./assets/icon-add-chat.svg";
import { ReactComponent as ContactIconColor } from "../../assets/contactIconColor.svg";
import { ReactComponent as AssetIconColor } from "../../assets/assetIconColor.svg";
import { ReactComponent as DocIconColor } from "../../assets/docIconColor.svg";
import { ReactComponent as TableIconColor } from "../../assets/tableIconColor.svg";
import { ReactComponent as FolderIconColor } from "../../assets/folderIconColor.svg";
import TruncatedText from "../FileExplorer/TruncatedText/TruncatedText";
import { setShowModal } from "../../../../slices/userSlices";
import { getTablesWithCounts } from "../../../../actions/user";
import { useTranslation } from "react-i18next";

const HomeExplorer = ({ 
    isOpen, 
    setIsOpen, 
    isTransparent, 
    setActiveFileExplore,
    activeFileExplore,
    zIndex,
    expanded,
    handleSidebarClose
}) => {
    const { t } = useTranslation(["Contacts","Assets"]);

    const navigate = useNavigate();
    const dispatch = useDispatch();


    const {
        user,
        tablesSidebar
    } = useSelector((state) => state.user);


    let isExpanded = isOpen;

    const [menuSections, setMenuSections] = useState([{
        name: t('expand'),
        icon: <IconExpand />,
        iconContracted: <IconContracted style={{width:"30px", height:"30px"}}/>,
        action: () => {
            if (isExpanded) {
                setIsOpen(false);
                isExpanded = false;
            } else {
                setIsOpen(true);
                isExpanded = true;
            }
        }
    }, {
        name: t('Panel'),
        // label: "Panel",
        icon: <IconPanel />,
        action: () => {
            // setIsOpen(false);
            navigate("/admin/home");
        }
    }, {
        name: t('Workflows'),
        // label: "Workflows",
        icon: <IconWorkflows />,
        label: 200,
        action: () => {
            dispatch(setShowModal('automate'));
        }
    }, {
        name: t('bots'),
        // label: "Bots",
        icon: <IconBots />,
        action: () => {
            // navigate("/admin/agent");
            dispatch(setShowModal('selectAgent'));
        }
    }, {
        name: t('conversations'),
        label: "Conversations",
        icon: <IconChats />,
        label: 200,
        action: () => {
            setIsOpen(true);
            setActiveFileExplore(false);
            navigate("/admin/chats");
        }
    }, {
        name: t('docs'),
        label: "Documentos",
        icon: <IconDoc />,
        label: 10,
        action: () => {
            setIsOpen(true);

            console.log('activeFileExplore', activeFileExplore)
            setActiveFileExplore(prev => !prev);
            // if(activeFileExplore) {
            //     setActiveFileExplore(false);
            // } else {
            // }
            // setIsOpen(true);
            // navigate("/admin/chats");
            // setIsOpen(true);
        }
    }, {
        name: t('calendar'),
        label: "Calendar",
        icon: <IconCalendar />,
        label: 2,
        action: () => {
            navigate("/admin/calendar");
        }
    }])

    const [menuPoints, setMenuPoints] = useState([{
        name: t('newDocument'),
        icon: <IconAddTransaction />,
        action: () => {
            // navigate("/admin/bill");
            dispatch(setShowModal('newBill'));
        }
    }, {
        name: t('uploadFile'),
        icon: <IconUpload />,
        action: () => {
            // console.log("Upload");
            // navigate("/admin/assets");
            dispatch(setShowModal('location'));

        }
    }, {
        name: t('more'),
        icon: <IconMore />,
        action: () => {
            console.log("More");
            // setActiveTab(true);
            // dispatch(setShowModal('more'));


            setMenuPoints(prevMenuPoints => {
                const arr = prevMenuPoints.filter(item => item.disabled == false);

                if (arr.length == 0) {
                    return [
                        prevMenuPoints[0],
                        prevMenuPoints[1],
                        prevMenuPoints[2],
                        ...prevMenuPoints.slice(3).map(item => ({
                            ...item,
                            disabled: false
                        }))
                    ];
                } else {
                    return [
                        prevMenuPoints[0],
                        prevMenuPoints[1],
                        prevMenuPoints[2],
                        ...prevMenuPoints.slice(3).map(item => ({
                            ...item,
                            disabled: true
                        }))
                    ];
                }
            });
        }
    }, {
        name: t('newTable'),
        icon: <IconAddTable />,
        disabled: true,
        action: () => {
            console.log("Tables");
            navigate("/admin/tables");
        }
    }, {
        name: t('newFolder'),
        icon: <IconAddFolder />,
        disabled: true,
        action: () => {
            console.log("Tables");
            // alert(1)
            dispatch(setShowModal('createFolder'));
        }
    }, {
        name: t('newContact'),
        icon: <IconAddContact />,
        disabled: true,
        action: () => {
            console.log("Tables");
            // navigate("/admin/contacts");
            dispatch(setShowModal('newContact'));
        }
    }, {
        name: t('newAsset'),
        icon: <IconAddAsset />,
        disabled: true,
        action: () => {
            console.log("Tables");
            // navigate("/admin/assets");
            dispatch(setShowModal('newAsset'));
        }
    }, {
        name: t('newChat'),
        icon: <IconAddChat />,
        disabled: true,
        action: () => {
            console.log("Tables");
            // alert(2)
            navigate("/admin/chats");
            // dispatch(setShowModal('newChat'));
        }
    }, {
        name: t('newWorkflow'),
        icon: <IconAddWorkflow />,
        disabled: true,
        action: () => {
            console.log("Tables");
            // alert(3)
            dispatch(setShowModal('automate'));
        }
    }, {
        name: t('newEvent'),
        icon: <IconAddEvent />,
        disabled: true,
        action: () => {
            console.log("Tables");
            // alert(5)
            // dispatch(setShowModal('newEvent'));
            navigate("/admin/calendar/week");
        }
    }])

    const [menuTables, setMenuTables] = useState([{
        name: t('tables'),
        icon: <TableIconColor />,
        // icon: <IconTables />,
        action: () => {
            console.log("Tables");
            // setActiveTab(true);
            navigate("/admin/tables");
        }
    },
        //  {
        //     name: "Documentos",
        //     icon: <IconDocument />,
        //     disabled: false,
        //     label: 200,
        //     action: () => {
        //         // console.log("Tables");
        //         navigate("/admin/docs/allDocs");
        //     }
        // }, {
        //     name: "Activos",
        //     icon: <IconAsset />,
        //     disabled: false,
        //     label: 300,
        //     action: () => {
        //         console.log("Tables");
        //         navigate("/admin/assets");
        //     }
        // }, {
        //     name: "Contactos",
        //     icon: <IconContact />,
        //     disabled: false,
        //     label: 400,
        //     action: () => {
        //         console.log("Tables");
        //         navigate("/admin/contacts");
        //     }
        // }, {
        //     name: "Tabla",
        //     icon: <IconAddFolder />,
        //     disabled: false,
        //     label: 500,
        //     action: () => {
        //         console.log("Tables");
        //         navigate("/admin/tables");
        //     }
        // }
    ])

    const [menuMore, setMenuMore] = useState([{
        name: t('explorerCommunity'),
        icon: <IconExploreCommunity />,
        action: () => {
            console.log("Tables");
            navigate('/admin/marketplace')
            // dispatch(setShowModal('exploreCommunity'));
        }
    }, {
        name: t('getPlus'), // Plan Plus
        icon: <IconStar />,
        action: () => {
            dispatch(setShowModal('plus'));
        }
    }, {
        name: t('setting'),
        icon: <IconConf />,
        action: () => {
            // console.log("Tables");
            let path = location.pathname.split("/");

            console.log('path', path)
            if (path[2]) {
                path = '/' + path[2]
            }

            navigate(`/admin${path}/settings/general`);
            dispatch(setShowModal('settings'));
        }
    }, {
        name: t('helpCenter'),
        icon: <IconHelp />,
        action: () => {
            // console.log("Tables");
            // navigate("/help");
            window.open('/help', '_blank');
        }
    }, {
        name: t('sendSuggestion'),
        icon: <IconSuggestion />,
        action: () => {
            // console.log("Tables");
            // navigate("/contacts");
            window.open('/contacts', '_blank');
        }
    }
    ]);


    const [isHoverPoint, setIsHoverPoint] = useState(null);
    const isHover = (e, name) => {
        if (!e) return setIsHoverPoint(null);

        const x = e.target.getBoundingClientRect().x;
        const y = e.target.getBoundingClientRect().y;
        setIsHoverPoint({ x, y, name });
    }

    const typeIcons = {
        // contacts: <IconContact />,
        // docs: <IconDocument />,
        // assets: <IconAsset />,
        // blank: <IconTables />,
        contacts: <ContactIconColor/>,
    docs: <DocIconColor />,
    assets: <AssetIconColor />,
    blank: <TableIconColor />,
    };

    useEffect(() => {
        const getTables = async () => {
            const res = await dispatch(getTablesWithCounts())
        }
        getTables()
    }, [])


    return (
        <>
            <div className={`${styles.container} ${isOpen ? styles.activeTab : ""} ${isTransparent ? styles.isTransparent : ""}`} style={zIndex} >

                {user?.payMethod?.length == 0 && (
                    <div className={styles.workspaceContainer}>
                        <div>
                            <IconWorkspace />
                        </div>
                        <b>
                            Workspace 1
                        </b>
                        <IconStar />
                    </div>
                )}

                <div className={styles.menuSections}>
                    {menuSections.map((item) => (
                        <div
                            key={item.name}
                            className={styles.menuItem}
                            onClick={(e) => {
                                e.stopPropagation()
                                item.action()
                                handleSidebarClose && handleSidebarClose()
                            }}
                            style={{
                                display: item.disabled ? "none" : "flex"
                            }}
                            onMouseEnter={(e) => isHover(e, item.name)}
                            onMouseLeave={(e) => isHover(null)}
                        >
                            <div className={styles.menuItemIcon}>
                                {item.name ==  t('expand') && isOpen ? item.iconContracted : item.icon}
                                {item.label && isOpen &&  (
                                <label>{item.label}</label>
                            )}
                            </div>
                            <span>{item.name}</span>
                            {item.label && (
                                <label>{item.label}</label>
                            )}
                        </div>
                    ))}
                </div>
                <div className={styles.menuSections}>
                    {menuPoints.map((item) => (
                        <div
                            key={item.name}
                            className={styles.menuItem}
                            onClick={() => {
                                item.action()
                                handleSidebarClose && handleSidebarClose()
                            }}
                            style={{
                                display: item.disabled ? "none" : "flex"
                            }}
                            onMouseEnter={(e) => isHover(e, item.name)}
                            onMouseLeave={(e) => isHover(null)}
                        >
                            <div className={styles.menuItemIcon}>
                                {item.icon}
                            </div>
                            <span>{item.name}</span>
                            {item.label && (
                                <label>{item.label}</label>
                            )}
                        </div>
                    ))}
                </div>
                <div className={styles.menuSections}>
                    {menuTables.map((item) => (
                        <div
                            key={item.name}
                            className={styles.menuItem}
                            onClick={() => {item.action()
                                handleSidebarClose && handleSidebarClose()
                            }}
                            style={{
                                display: item.disabled ? "none" : "flex"
                            }}
                            onMouseEnter={(e) => isHover(e, item.name)}
                            onMouseLeave={(e) => isHover(null)}
                        >
                            <div className={styles.menuItemIcon} style={{color:item.color}} >
                                {item.icon}
                            </div>
                            <span>{item.name}</span>
                            {item.label && (
                                <label>{item.label}</label>
                            )} 
                        </div>
                    ))}
                    {tablesSidebar.map((item) => (
                        <div
                            key={item._id}
                            className={styles.menuItem}
                            onClick={() => {navigate(`/admin/tables/${item._id}`)
                            handleSidebarClose && handleSidebarClose()
                        }}
                            // style={{
                            //     display: item.disabled ? "none" : "flex"
                            // }}
                            onMouseEnter={(e) => isHover(e, item.name)}
                            onMouseLeave={(e) => isHover(null)}
                        >
                            <div className={`${styles.menuItemIcon} ${styles.tablesIcon}`} style={{color:item.color}}>
                                {/* {console.log('esto es item', item)} */}
                                {typeIcons[item.type] || typeIcons['contacts']}
                                 {item.rowCount > 0 && isOpen &&  (
                                <label>{item.rowCount}</label>
                            )}
                                {/* {item.icon} */}
                            </div>
                           { !isOpen && <TruncatedText style={{ width: "100%" }} text={item.name || t(item.type)} />}
                            {/* <span>{item.name || t(item.type)}</span> */}
                            {item.rowCount > 0 && (
                                <label>{item.rowCount}</label>
                            )}
                        </div>
                    ))}
                    <div>
                        imposible
                    </div>
                </div>
                <div className={styles.menuSections}>
                    {menuMore.map((item) => (
                        <div
                            key={item.name}
                            className={styles.menuItem}
                            onClick={() => {item.action()
                                handleSidebarClose && handleSidebarClose()
                            }}
                            style={{
                                display: item.disabled ? "none" : "flex"
                            }}
                            onMouseEnter={(e) => isHover(e, item.name)}
                            onMouseLeave={(e) => isHover(null)}
                        >
                            <div className={styles.menuItemIcon}>
                                {item.icon}
                            </div>
                            <span>{item.name}</span>
                            {item.label && (
                                <label>{item.label}</label>
                            )}
                        </div>
                    ))}
                </div>
            </div>
            {/* {isHoverPoint && ( */}
            {isHoverPoint && (
                <div
                    className={`${styles.tooltip} ${isOpen ? styles.active : ""}`}
                    style={{
                        position: "absolute",
                        top: isHoverPoint?.y || 100,
                        // left: isHoverPoint?.x || 40,
                        left: 64,
                        zIndex: 1000
                    }}>
                    {isHoverPoint?.name || "test"}
                </div>
            )}


            {/* <TableInfo /> */}
        </>
    );
};

export default HomeExplorer;